import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function LanguageSwitcher() {
    const { i18n } = useTranslation();

    // السحر هنا: أول ما اللغة تتغير، بنغير اتجاه الـ HTML كله لـ rtl أو ltr
    useEffect(() => {
        const dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
        document.documentElement.dir = dir;
        document.documentElement.lang = i18n.language;
    }, [i18n.language]);

    const toggleLanguage = () => {
        const nextLang = i18n.language === 'en' ? 'ar' : 'en';
        i18n.changeLanguage(nextLang);
    };

    return (
        <button
            className="btn btn-sm btn-outline-secondary fw-bold ms-2 me-2"
            onClick={toggleLanguage}
        >
            {i18n.language === 'en' ? 'عربي' : 'English'}
        </button>
    );
}